// Hari K:08-11-2023 :BT-119138:Funds View - funds-transfer funds modal-start
import { forwardRef, memo, useEffect, useState } from "react";
import { BzButton, BzInputText, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../components";
import { Row, Col, Container, Dropdown } from "react-bootstrap";
import { handleModal, handleModalData } from "../../redux/actions/modals";
import { useDispatch, useSelector } from "react-redux";
import { getFundTransferMappedProduct, getFundsTransfer } from "../../redux/actions/funds";
import { _commaFormatter, _kFormatter } from "../../controllers";
import { getAppInfoData } from "../../utils/global_functions";
import { APP_INFO_PARAMS } from "../../utils/global_variables";
import { toastConfig } from "../../redux/actions/toast";


const TransferModal = ({ activeMarket, setActiveMarket, }) => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const productWiseBalance = useSelector(state => state.funds.allowedMarkets);
    const transferMappedProduct = useSelector(state => state.funds.transferMappedProduct);
    const objFundsMaxAmount = getAppInfoData(APP_INFO_PARAMS.APP_FUND_MAX_AMT);


    const [transferInputs, setTransferInputs] = useState({ addAmount: 0, productTwo: {} });
    const [arrActiveMappedProducts, setArrActiveMappedProducts] = useState()
    const [isSatisfiedAllparameters, setIsSatisfiedAllparameters] = useState(true)
    const data = getAppInfoData(APP_INFO_PARAMS.APP_FUNDS_CONFIG);
    const fundsConfig = Array.isArray(data) ? data[0] : data;//added by abhijeet v:20260224 for tickit 204283
    // let nMaxInputLength = objFundsMaxAmount?.transfer ? objFundsMaxAmount?.transfer?.length : FUNDS_DEFAULT_INPUT_LENGTH.TRANSFER_FUNDS;
    useEffect(() => {
        if (transferMappedProduct?.length && productWiseBalance?.length) {
            const activeMappedProducts = productWiseBalance?.filter(item => transferMappedProduct?.some(each => item?.sProductId?.toString() === each?.nToProductId?.toString()))
            setArrActiveMappedProducts(activeMappedProducts)
            setTransferInputs({ ...transferInputs, productTwo: activeMappedProducts[0] });
        } else {
            setArrActiveMappedProducts()
            setTransferInputs({ ...transferInputs, productTwo: {} });
        }
    }, [transferMappedProduct, productWiseBalance]);


    const handleOrderInputs = (amount) => {
        setTransferInputs({ ...transferInputs, addAmount: amount });
    };

    const handleAddTransfer = (value) => {
        setTransferInputs({ ...transferInputs, productTwo: value });
    };

    const handleClose = () => {
        setTransferInputs({ addAmount: 0, productTwo: {} })
        dispatch(handleModal([{ "TRANSFER_MODAL": false }]));
    };

    useEffect(() => {
        if (transferInputs?.addAmount > 0 &&
            transferInputs?.productTwo &&
            Object.keys(transferInputs.productTwo).length &&
            activeMarket &&
            Object.keys(activeMarket).length
        ) {
            setIsSatisfiedAllparameters(false)
        } else {
            setIsSatisfiedAllparameters(true)
        }
    }, [activeMarket, transferInputs])



    const handleSubmitButton = () => {
        setIsSatisfiedAllparameters(true)
        if ((Object.keys(transferInputs?.productTwo)?.length)) {
            if (transferInputs?.addAmount > 0 && Object.keys(transferInputs?.productTwo)?.length && Object.keys(activeMarket)?.length) {
                if (Number(transferInputs?.addAmount) < Number(activeMarket?.balanceAmount)) {
                    if (Number(transferInputs?.addAmount) <= Number(objFundsMaxAmount?.transfer) || objFundsMaxAmount?.transfer === undefined) {
                        let objPayload = {
                            "moveFromProductID": activeMarket?.sProductId,
                            "moveToProductID": transferInputs?.productTwo?.sProductId,
                            "transferAmount": transferInputs?.addAmount,
                        }
                        dispatch(getFundsTransfer(objPayload))?.then(() => {
                            setIsSatisfiedAllparameters(false)
                            dispatch(handleModalData({ transactionType: "FT" }));
                            dispatch(handleModal([{ "SUCCESS_MODAL": true }]));
                            dispatch(handleModal([{ "TRANSFER_MODAL": false }]));
                        })?.catch((error) => {
                            console.error(error, "error")
                            dispatch(toastConfig({ autoDismiss: true, show: true, message: `Ooop!! Please try again...` }));
                            setIsSatisfiedAllparameters(false)
                        })
                    } else {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `Please enter Amount between 0 to ${Number(objFundsMaxAmount?.transfer)}` }));
                    }
                } else {
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: `Transfer amount should be less than the available amount` }));
                }
            } else { }
        } else {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: `to transfer not available` }));
        }
    };

    const handleProductChange = (value) => {
        setActiveMarket(value)
        dispatch(getFundTransferMappedProduct(value?.sProductId))
    };


    const CustomDropdownToggle = forwardRef(({ children, onClick }, ref) => (
        <div
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
        >
            {children}
        </div>
    ));

    return (
        // SumitG-08-12-23
        <BzModal show={modals['TRANSFER_MODAL']} onHide={handleClose} centered data-testid='funds-transfer-modal'>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={10} className='d-flex justify-content-start align-items-center add-funds-dropdown-wrapper'>
                            <Dropdown data-testid='funds-transfer-modal-product-dropdown'>
                                <Dropdown.Toggle as={CustomDropdownToggle} data-testid='funds-transfer-modal-product-dropdown-toggle'>
                                    <div className='d-flex justify-content-start align-items-center'>
                                        <div data-testid='funds-transfer-modal-product-selected-item' className='font-medium font-size3 color-text'>{activeMarket?.sProductName} (Balance: ₹ {_commaFormatter(_kFormatter(parseFloat(activeMarket?.balanceAmount)))})</div>
                                        <div className='icon-20 icon-sort-down icon-dark ms-2'></div>
                                    </div>
                                </Dropdown.Toggle>
                                {productWiseBalance && productWiseBalance?.length > 0 ?
                                    <Dropdown.Menu data-testid='funds-transfer-modal-product-dropdown-menu'>
                                        {productWiseBalance && productWiseBalance?.length > 0 && productWiseBalance?.map((eachProduct, i) => (
                                            <Dropdown.Item data-testid={`funds-transfer-modal-product-dropdown-item-${i}`} key={i} onClick={() => { handleProductChange(eachProduct); }} value={eachProduct.sProductId}>{eachProduct?.sProductName} (Balance: ₹{_commaFormatter(_kFormatter(parseFloat(eachProduct?.balanceAmount)))})</Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                    : null}
                            </Dropdown>
                        </Col>
                        <Col md={2} className='d-flex justify-content-end align-items-center'>
                            <div data-testid='funds-transfer-modal-close-icon' className='icon-16 icon-dark icon-close' onClick={handleClose}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Row className='g-0 d-flex align-items-center mb-3'>
                    <Col md={4} className='pe-4'>
                        <div data-testid='funds-transfer-modal-title' className='font-medium font-size9 color-text text-wrap'>Transfer <div className='break-line'>Funds</div></div>
                    </Col>
                    <Col md={8}>
                        <div className='input-group align-items-center add-funds-input'>
                            <span className='font-medium font-size9 color-text me-1'>&#8377;</span>
                            <BzInputText data-testid='funds-transfer-modal-amount-input' type="number" name="add amount" value={transferInputs?.addAmount} className='text-start font-size9 p-0 form-control font-medium bdr-none' onChange={(e) => handleOrderInputs(e.target.value)} max={Number.POSITIVE_INFINITY} />
                        </div>
                    </Col>
                </Row>
                <Row className='g-0 my-2'>
                    <Col>
                        <div data-testid='funds-transfer-modal-to-account-text' className='font-regular font-size4 color-text'>To Account</div>
                    </Col>
                </Row>
                <Row className='g-0 mb-2'>
                    <Col className='d-flex justify-content-start align-items-center add-funds'>
                        {arrActiveMappedProducts?.length > 0 && arrActiveMappedProducts?.map((each, i) => (
                            <div data-testid={`funds-transfer-modal-product-card-${i}`} key={each?.nToProductId} className={transferInputs?.productTwo?.sProductName === each?.sProductName ? 'addfunds-modal-radio-card active me-3' : 'addfunds-modal-radio-card me-3'} onClick={() => handleAddTransfer(each)}>
                                <input data-testid={`funds-transfer-modal-product-card-radio-${i}`} type='radio' className='form-check-input mb-3' checked={transferInputs?.productTwo?.sProductName === each?.sProductName} />
                                <div className='font-medium font-size6 text-uppercase mb-1'>{each?.sProductName}</div>
                                <div className='font-regular font-size4'>&#8377;{_commaFormatter(_kFormatter(parseFloat(each.balanceAmount)))}</div>
                            </div>
                        ))}
                    </Col>
                </Row>
                <Row className='g-0'>
                    <Col>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                    </Col>
                </Row>
            </BzModalBody>
            <BzModalFooter className='bdr-none'>
                <Container fluid className='p-0 m-0'>
                  {fundsConfig?.FTdisclaimer ?
                     <Row className='g-0 py-2 mb-2'>
                        <Col className='d-flex justify-content-center'>
                            <div data-testid='funds-withdrawal-modal-disclaimer-text' className='font-regular font-size2 color-text'><span>Note:</span>{fundsConfig?.FTdisclaimer}</div>
                        </Col>
                    </Row> : null}
                    <Row className='g-0'>
                        <Col>
                            <BzButton data-testid='funds-transfer-modal-transfer-button' className='btn btn-md btn-primary btn-block' disabled={isSatisfiedAllparameters} onClick={handleSubmitButton}>Transfer Funds</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
    );
};

export default memo(TransferModal);
// Hari K:08-11-2023 :BT-119138:Funds View - funds-transfer funds modal-start